import { useState } from "@wordpress/element";
import {
  useBlockProps,
  RichText,
  MediaUpload,
  InspectorControls,
} from "@wordpress/block-editor";
import { Button, PanelBody } from "@wordpress/components";

export default function Edit({ attributes, setAttributes }) {
  const { slides = [] } = attributes;

  const addSlide = () => {
    const newSlides = [
      ...slides,
      {
        backgroundImage: "",
        title: "",
        secondTitle: "",
        text: "",
        buttonText: "",
        buttonUrl: "",
        rightImage: "",
      },
    ];
    setAttributes({ slides: newSlides });
  };

  const removeSlide = (index) => {
    const newSlides = slides.filter((_, i) => i !== index);
    setAttributes({ slides: newSlides });
  };

  const updateSlide = (index, key, value) => {
    const newSlides = [...slides];
    newSlides[index][key] = value;
    setAttributes({ slides: newSlides });
  };

  const removeImage = (index, key) => {
    updateSlide(index, key, "");
  };

  return (
    <div {...useBlockProps()}>
      <h3>Slider de bannières</h3>
      {slides.map((slide, index) => (
        <div
          key={index}
          className="slide-editor"
          style={{ border: "1px solid #ccc", padding: 15, marginBottom: 20 }}
        >
          <strong>Diapositive {index + 1}</strong>
          <MediaUpload
            onSelect={(media) =>
              updateSlide(index, "backgroundImage", media.url)
            }
            allowedTypes={["image"]}
            render={({ open }) => (
              <>
                <Button onClick={open} style={{ marginTop: 10 }}>
                  {slide.backgroundImage
                    ? "Changer l’image d’arrière-plan"
                    : "Définir l’image d’arrière-plan"}
                </Button>
                {slide.backgroundImage && (
                  <Button
                    onClick={() => removeImage(index, "backgroundImage")}
                    isDestructive
                    style={{ marginLeft: 10 }}
                  >
                    Supprimer
                  </Button>
                )}
              </>
            )}
          />
          {slide.backgroundImage && (
            <img
              src={slide.backgroundImage}
              alt="Aperçu"
              style={{ marginTop: 10, maxWidth: "100%", height: "auto" }}
            />
          )}

          <RichText
            tagName="h2"
            value={slide.title}
            onChange={(val) => updateSlide(index, "title", val)}
            placeholder="Titres"
          />
          <RichText
            tagName="h2"
            value={slide.secondTitle}
            onChange={(val) => updateSlide(index, "secondTitle", val)}
            placeholder="Deuxième titre"
          />
          <RichText
            tagName="p"
            value={slide.text}
            onChange={(val) => updateSlide(index, "text", val)}
            placeholder="Description"
          />
          <RichText
            tagName="a"
            value={slide.buttonText}
            onChange={(val) => updateSlide(index, "buttonText", val)}
            placeholder="Texte du bouton"
          />
          <input
            type="url"
            placeholder="URL du bouton"
            value={slide.buttonUrl}
            onChange={(e) => updateSlide(index, "buttonUrl", e.target.value)}
            style={{ width: "100%", margin: "10px 0" }}
          />
          <div className="align-left">
            {slide.rightImage && ( <img 
              src={slide.rightImage} 
              alt="Aperçu" 
              width="300"
              height="300"
            />
            )}
            <MediaUpload
              onSelect={(media) => updateSlide(index, "rightImage", media.url)}
              allowedTypes={["image"]}
              render={({ open }) => (
                <>
                  <Button onClick={open}>
                    {slide.rightImage
                      ? "Changer l’image de droite"
                      : "Téléverser l’image de droite"}
                  </Button>
                  {slide.rightImage && (
                    <Button
                      onClick={() => removeImage(index, "rightImage")}
                      isDestructive
                      style={{ marginLeft: 10 }}
                    >
                      Supprimer
                    </Button>
                  )}
                </>
              )}
            />
        </div>
          <Button
            onClick={() => removeSlide(index)}
            isDestructive
            style={{ marginTop: 15 }}
          >
            Supprimer la diapositive
          </Button>
        </div>
      ))}
      <Button onClick={addSlide} isPrimary>
        Ajouter une diapositive
      </Button>
    </div>
  );
}
